import moment from "moment";

const CommonService = {
  isUndefinedOrNull(param) {
    let retVal = false;
    if (param == null) retVal = true;
    return retVal;
  },
  nullToDefaultValue(param, defaultValue) {
    let retVal = param;
    if (param == null) retVal = defaultValue;
    return retVal;
  },
  isGuidEmpty(param) {
    var retVal = false;
    if (!param) retVal = true;
    if (param === "" || param === "00000000-0000-0000-0000-000000000000")
      retVal = true;
    return retVal;
  },
  isDateValid(dt) {
    return moment(dt, 'YYYY-MM-DD',true).isValid()
  }
};

export default CommonService;
